import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ContractInterface, GetContractUseCase, GetProfileUseCase, UserInterface } from '../../../core';
import { ErrorDialog } from '../../ui/dialog/error/error.dialog';
import { Loader } from '../../client/helpers/loader';

import { environment } from '../../../../environments/environment';

@Component({
    templateUrl: './full-data.page.html',
    styleUrls: ['./full-data.page.scss'],
})
export class FullDataPage implements OnInit {
    public contract: ContractInterface;
    public user: UserInterface;
    public showBack = false;
    public isClientPortal = environment.portalClient;

    constructor(
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private getProfileUseCase: GetProfileUseCase,
        public loader: Loader
    ) {}

    ngOnInit() {
        this.getContract();
        this.getProfile();
    }

    private getContract() {
        this.getContractUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (data) => (this.contract = data),
                (error) => this.dialog.open(ErrorDialog, { data: { text: error } })
            );
        });
    }

    private getProfile() {
        this.getProfileUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (data) => (this.user = data),
                (error) => this.dialog.open(ErrorDialog, { data: { text: error } })
            );
        });
    }

    showBackButton() {
        this.showBack = true;
    }

    hideBackButton() {
        this.showBack = false;
    }

    onBack() {
        window.history.back();
    }
}
